import React from 'react';
import { CircleCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ProductFamily } from '../../../../../common/models/product-family.model';
import { useResolveTranslation } from '../../../../../common/hooks/use-resolve-translation.hook';

interface FamilyStepProps {
  families: ProductFamily[];
  selectedFamilyId: string | null;
  onSelect: (familyId: string) => void;
}

export const FamilyStep: React.FC<FamilyStepProps> = ({
  families,
  selectedFamilyId,
  onSelect,
}) => {
  const { rt } = useResolveTranslation();

  return (
    <div className="grid grid-cols-2 gap-4">
      {families.map((family) => {
        const isSelected = selectedFamilyId === family._id;

        return (
          <div
            key={family._id}
            data-testid={`family-card-${family._id}`}
            onClick={() => onSelect(family._id)}
            className={cn(
              'relative flex w-full cursor-pointer flex-col items-center justify-center gap-2 border-[1.5px] bg-card p-6 text-center transition-colors',
              isSelected ? 'border-foreground' : 'border-border hover:border-foreground/40'
            )}
          >
            {isSelected && (
              <CircleCheck className="absolute top-2.5 end-2.5 size-5 text-foreground" />
            )}
            <p className="text-sm font-medium text-foreground">{rt(family.name)}</p>
            {family.description && (
              <p className="text-xs leading-snug text-muted-foreground">
                {rt(family.description)}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};
